import { Order } from '@cemex-core/cmx-api';
import { Action } from '@ngrx/store';

export enum OneClickHolidaysActionTypes {
  LOAD_HOLIDAYS = '[One Click] Load holidays',
}

export class OneClickLoadHolidaysAction implements Action {
  readonly type = OneClickHolidaysActionTypes.LOAD_HOLIDAYS;

  constructor(public payload: Order) {}
}

export type OneClickHolidaysActions = OneClickLoadHolidaysAction;
